import { render } from "./LaboratoirePage.vue?vue&type=template&id=3f877ccc"
import script from "./LaboratoirePage.vue?vue&type=script&lang=js"
export * from "./LaboratoirePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__